import { isString } from './string';
import { getRootWindow } from './window';

export const SUPPORTED_LANGUAGES = ['en', 'fr', 'de', 'es', 'pt'];
export const DEFAULT_LANGUAGE = 'en';

function isSupportedLanguage(lang: string | null | undefined): boolean {
  return isString(lang)
    ? SUPPORTED_LANGUAGES.includes(lang.toLowerCase())
    : false;
}

export const toShortLang = (lang: string | null | undefined): string =>
  isString(lang) ? lang.trim().substring(0, 2).toLowerCase() : '';

export function getUserLanguage(short: boolean = false): string {
  const processFunc = short ? toShortLang : (lang: string) => lang;
  const localLang = getRootWindow().localStorage.getItem('language');
  if (localLang) {
    // Trust this one.
    return processFunc(localLang);
  }

  const { navigator } = getRootWindow();

  // If navigator.languages is filled check this first.
  if (navigator.languages?.length > 0) {
    for (const lang of navigator.languages) {
      if (isSupportedLanguage(processFunc(lang))) {
        return processFunc(lang);
      }
    }
    // If nothing matched try the base languages.
    if (!short) {
      for (const lang of navigator.languages) {
        if (isSupportedLanguage(toShortLang(lang))) {
          return toShortLang(lang);
        }
      }
    }
  }

  // Try legacy places.
  const language = navigator.language || '';
  if (isSupportedLanguage(language)) {
    return processFunc(language);
  }

  return DEFAULT_LANGUAGE;
}

export function getByLocale(dict: { [lang: string]: string }): string {
  const locale = toShortLang(getUserLanguage() || DEFAULT_LANGUAGE);
  return dict[locale] || dict[DEFAULT_LANGUAGE];
}
